/* 
Bridge de comunicación con la Api, diferentes funciones para coger información de los articulos de ilusiona.
*/

import { POSTDATA, CAPITALIZEFIRSTLETTER } from "../constants";
import { LOCAL } from "../config";

export default class Gift {
  static INSTANCE = new Gift();

  listGift = [ //Ejemplo de un articulo/regalo
    {
      name: "AURICULARES PLEGABLES COLOR PASTEL",
      points: 100,
      image: "gift1.jpg"
    }
  ];

  Gift() { }

  getListGift = (filter, from, to, order) => {
    let filtro = {
      idCentro: filter.idCenter,
      nombre: filter.name,
      familia: filter.family === "0" ? undefined : filter.family,
      puntos: filter.points ? JSON.stringify(filter.points) : undefined
    };

    for (let atr in filtro) {
      let variable = filtro[atr];
      if (!variable) {
        delete filtro[atr];
      }
    }

    return new Promise((resolve, reject) => {
      if (!LOCAL) {
        let url = `/ArticuloCompras/Filtro?from=${from}&to=${to}&order=${order}&source=web`;

        POSTDATA(url, filtro, response => {
          const primerItem = response.data.listGift?.[0];
          //if (primerItem) console.log('[DEBUG] Foto field:', primerItem.Foto, 'Tipo:', typeof primerItem.Foto);
          const parseResponse = response.data.listGift.map(item => {
            const foto = item.Foto;
            const imageUrl = foto && typeof foto === 'string' && foto.startsWith('http')
              ? foto
              : `https://ilusionastoragedev.blob.core.windows.net/fotos/${foto || ''}`;
            return {
              id: item.Id,
              name: CAPITALIZEFIRSTLETTER(item.Nombre.trim()),
              points: item.Puntos,
              stock: item.Stock,
              image: imageUrl
            };
          });
          resolve({ numOfGift: response.data.numOfGift, listGift: parseResponse });
        }, error => {
          reject(error);
        });
      } else {
        resolve({ numOfGift: 1, listGift: this.listGift });
      }
    });
  };
}
